export const sessionStorageKeys = {
  KEY_SAVE_LAYOUT: 'saveLayout',
  KEY_ROUTE: 'route',
}

export const localStorageKeys = {
  KEY_LANGUAGE: 'language',
  KEY_TIMEZONE: 'timeZone',
  KEY_FONT_SIZE: 'fontSize',
  KEY_START_TIME_SESSION_EXPIRED:
    'common/popup/sessionExpired/startTimeInterval',
  KEY_LOGOUT: 'logout',
  KEY_PERSIST_STORE: 'persistRoot',
  CURRENT_LOCATION: 'currentLocation',
  ORGANIZATION_ID: 'organizationId',
  RETURN_URL: 'returnUrl',
}

export const EMPTY_VALUE = 'N/A'
export const ZERO_IN_FINANCIAL_STATEMENT = '-'

export const COMPANY_TYPES = {
  CORPORATE: 'CT',
  BANK: 'NH',
  NON_BANK: 'NonBank',
  SECURITIES: 'CK',
  FUNDS: 'QU',
  INSURANCE: 'BH',
  LIFE_INSURANCE: 'BHNT',
  NON_LIFE_INSURANCE: 'BHPNT',
}

export const COMPANY_NON_BANK_TYPES = {
  NON_BANK_FIO: 'FIO',
  NON_BANK_FIC: 'FIC',
  NON_BANK_LEA: 'LEA',
}

export const Z_INDEX = {
  MODAL: 13,
}

export const SORT_DIRECTION = {
  ASC: 'Ascending',
  DESC: 'Descending',
}

export const CLASS_HIDE_TABLE_PDF = 'classHideTablePdf'

export const MAX_COMPANY_IN_PORTFOLIO = 500

export const MAX_PORTFOLIO = 300

export const TYPES_DISCOUNT = {
  SNPOrder: 'SNPOrder',
  Subscription: 'Subscription',
  Package: 'Package',
  Order: 'Order',
}
